export const mainCls = 'input-container';

export default {
  [`${mainCls}`]: {
    position: 'relative',
    '&__input' :{
        position: 'relative',
        zIndex: 1,
    },
    '&__canc-btn': {
        width: '0px',
        overflow: 'hidden',
        textAlign: 'right',
        willChange: 'width',
        '&--s': {
            width: '65px',
        }
    }
  }
}